var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Element',{attrs:{"tag":_vm.tag}},[_vm._l((_vm.titleSplit),function(str,index){return [(index % 2 === 0)?[_vm._v(_vm._s(str))]:_c('Element',{key:str,attrs:{"tag":_vm.highlightTag}},[_vm._v(_vm._s(str))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }